<div class="row">
  <div class="middle-container">
    <div class="detail-breadcrumb">
      <span> CPP Quote Number: {{quoteNumber}} </span>
    </div>
    <div class="">
      <div class="tableContainer dealertableContainer">
        <table mat-table [dataSource]="quoteDetail" multiTemplateDataRows class="matTables">
          <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedHeaderTableCol">
            <div *ngIf="column=='account'"><th mat-header-cell *matHeaderCellDef class="">Account Name</th>
      </div>
      <div *ngIf="column=='status'"><th mat-header-cell *matHeaderCellDef class="text-center">Status</th></div>
      <div *ngIf="column=='quoteDate'"><th mat-header-cell *matHeaderCellDef class="text-center">Quote Date</th></div>
      <div *ngIf="column=='closeDate'"><th mat-header-cell *matHeaderCellDef class="text-center">Close Date</th></div>
      <div *ngIf="column=='preparedBy'"><th mat-header-cell *matHeaderCellDef class="text-center">Prepared By</th></div>
      <div *ngIf="column=='preparedFor'"><th mat-header-cell *matHeaderCellDef class="text-center">Prepared For</th></div>
      <td mat-cell *matCellDef="let element">
        <div *ngIf="column=='account'">
          <div class="order-info defaultCursor margin-l0">
            <p> <span>{{element.accountName}}</span> </p>
            <p class="grower-name">{{element.address}}, {{element.city}}, {{element.state}} {{element.zipcode}}</p>
          </div>
        </div>
        <div *ngIf="column=='status'" class="text-center largeTableTxt">
          <ng-container> {{element.status}}</ng-container>
        </div>
        <div *ngIf="column=='quoteDate'" class="text-center largeTableTxt">
          <ng-container> {{element.quoteDate  | date:'MM/dd/yyyy'}}</ng-container>
        </div>
        <div *ngIf="column=='closeDate'" class="text-center largeTableTxt">
          <ng-container> {{element.closeDate | date:'MM/dd/yyyy'}}</ng-container>
        </div>
        <div *ngIf="column=='preparedBy'" class="text-center largeTableTxt">{{element.preparedBy}}</div>
        <div *ngIf="column=='preparedFor'" class="text-center largeTableTxt">
          <ng-container> {{element.preparedFor }}</ng-container>
        </div>
      </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedHeaderTableCol;sticky:true;"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedHeaderTableCol;" class="example-element-row"></tr>
      </table>
    </div>
    <div class="form-sec xs-mt-20">
      <div class="row account-filter">
        <div class="col-md-12 col-lg-12 padding-l0 padding-r0 smallPadRgt0">
          <div class="row search-box-outer margin-b10">
            <div class="col-md-4 col-lg-3 padding-r0 borderRight category-drop-outer">
              <div class="category-dropdown material-select">
                <ng-select [items]="searchTypeList"
                           name="ddlViewQuoteSearch"
                           [(ngModel)]="selectedValue"
                           [virtualScroll]="true"
                           [closeOnSelect]="true"
                           [selectOnTab]="true"
                           [clearable]="false"
                           bindValue="value"
                           labelForId="name"
                           [searchable]="false"
                           (change)="retainFilter(null, ' ', false)">
                </ng-select>
              </div>
            </div>
            <div class="col-md-8 col-lg-9 padding-l0 padding-r0">
              <div class="material-select account-search">

                <!-- Account Name -->
                <div #orderSearch *ngIf="selectedValue === 'Account Name'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter($event);" [(ngModel)]="orderFilters.AccountName" placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Account Number -->
                <div #orderSearch *ngIf="selectedValue === 'Account Number'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ',false);" [(ngModel)]="orderFilters.AccountNumber"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Product Name -->
                <div #orderSearch *ngIf="selectedValue === 'Product Name'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ',false);" [(ngModel)]="orderFilters.ProductName"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Item Number -->
                <ng-select #orderSearch name="ddlItemNoSearch" *ngIf="selectedValue === 'Item Number'"
                           [items]="itemNumberList"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="orderFilters.ItemNumber"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           (change)="retainFilter(itemNumber,'ItemNumber',false)">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>

                <!-- Order Number -->
                <div #orderSearch *ngIf="selectedValue === 'Order Number'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ',false);" [(ngModel)]="orderFilters.OrderNumber"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Customer PO# -->
                <div #orderSearch *ngIf="selectedValue === 'Customer PO#'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ',false);" [(ngModel)]="orderFilters.CustomerPO"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Requested Arrival Date -->
                <div class="d-flex">
                  <div #orderSearch class="col-md-6 maturitySelect padding-l0 xs-pl-15" *ngIf="selectedValue === 'Requested Arrival Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromRequestedDeliveryDateFilter"
                               readonly [(ngModel)]="orderFilters.FromRequestedDeliveryDate" (dateChange)="retainFilter(null, ' ',false);validateRequestedDeliveryDateFilter('fromRequestedDeliveryDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div #orderSearch class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Requested Arrival Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toRequestedDeliveryDateFilter"
                               readonly [(ngModel)]="orderFilters.ToRequestedDeliveryDate" (dateChange)="retainFilter(null, ' ',false);validateRequestedDeliveryDateFilter('toRequestedDeliveryDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 padding-r0">
          <div class="chips-sec">
            <div class="row selected-chip">
              <div class="col-sm-9 col-md-10 padding-l0">
                <div>
                  <mat-chip-set>
                    <mat-chip selected *ngFor="let filterValue of filterValueList">
                      {{filterValue}}
                      <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                        <i class="fas fa-times text-right"></i>
                      </a>
                    </mat-chip>
                  </mat-chip-set>
                </div>
              </div>
              <div class="col-sm-3 col-md-2 text-right padding-r30" *ngIf="filterValueList && filterValueList.length > 0">
                <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="">
      <div class="">
        <div class="tableContainer view-tbl">
          <div class="tableTopSec">
            <div class="row xs-m-0">
              <div class="col-xl-4 col-lg-4 col-md-4 padding-l30">
              </div>
              <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                <mat-paginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
              </div>
            </div>
          </div>
          <div class="tableComponentOuter">
            <table mat-table [dataSource]="viewQuoteOrderDS" matSort matSortDirection="desc" class="matTables">
              <ng-container matColumnDef="orderNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Order Number</th>
                <td mat-cell *matCellDef="let element" style="width:10%;">
                  {{element.orderNumber}}
                </td>
              </ng-container>
              <ng-container matColumnDef="shipTo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Ship/Deliver To</th>
                <td mat-cell *matCellDef="let element" class="order-info defaultCursor " style="width:18%;">
                  <p class="grower-name">
                    {{element.shipTo}}
                  </p>
                  <p>{{element.address}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="custPO">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> PO#</th>
                <td mat-cell *matCellDef="let element" style="width:7%;">
                  {{element.custPO}}
                </td>
              </ng-container>

              <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Product</th>
                <td mat-cell *matCellDef="let element" style="width:14%;">
                  {{element.product}}
                </td>
              </ng-container>
              <ng-container matColumnDef="uom">
                <th mat-header-cell *matHeaderCellDef class="text-center w70"> UOM</th>
                <td mat-cell *matCellDef="let element" class="text-center" style="width:5%;">
                  {{element.uom}}
                </td>
              </ng-container>
              <ng-container matColumnDef="shipQty">
                <th mat-header-cell *matHeaderCellDef class="text-center w70"> Ship Qty</th>
                <td mat-cell *matCellDef="let element" class="text-center" style="width:5%;">
                  {{element.shipQty}}
                </td>
              </ng-container>

              <ng-container matColumnDef="unitPrice">
                <th mat-header-cell *matHeaderCellDef class="text-center w70"> Unit Price</th>
                <td mat-cell *matCellDef="let element" class="text-center" style="width:5%;">
                  {{element.unitPrice | number:'1.4-4'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="priceUOM">
                <th mat-header-cell *matHeaderCellDef class="text-center w70"> Price UOM</th>
                <td mat-cell *matCellDef="let element" class="text-center" style="width:6%;">
                  {{element.priceUOM }}
                </td>
              </ng-container>

              <ng-container matColumnDef="qtyPriced">
                <th mat-header-cell *matHeaderCellDef class="text-center w70"> Qty Priced</th>
                <td mat-cell *matCellDef="let element" class="text-center" style="width:5%;">
                  {{element.qtyPriced}}
                </td>
              </ng-container>

              <ng-container matColumnDef="totalPrice">
                <th mat-header-cell *matHeaderCellDef class="text-center w70"> Total Price</th>
                <td mat-cell *matCellDef="let element" class="text-center" style="width:5%;">
                  ${{element.totalPrice | number:'1.2-2'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="packageSize">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Package Size</th>
                <td mat-cell *matCellDef="let element" class="text-center" style="width:7%;">
                  {{element.packageSize}}
                </td>
              </ng-container>

              <ng-container matColumnDef="requestedDeliveryDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="justify-content-center-child"> Requested Arrival Date </th>
                <td mat-cell *matCellDef="let element" class="text-center" style="width:8%;"> {{element.requestedDeliveryDate | date:'MM/dd/yyyy' }} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
          <div *ngIf="filterQuoteOrderDSitems == undefined || filterQuoteOrderDSitems.length == 0" class="noDataMsg noDataBg">
            <p>No Record Found.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer-action">
  <div class="row">
    <div class="col-md-11 ml-auto mr-auto d-flex">
      <div class="flex-one">
        <button mat-raised-button class="btns xs-ml-15" color="primary" [style.display]="'inline-block'" (click)="backToLandingPage()">Back To Order List</button>
        <button mat-raised-button class="btns xs-ml-15" color="primary" [style.display]="'inline-block'" (click)="backToQuote()">Back To Quote</button>
      </div>
      <button mat-raised-button class="btns xs-ml-15" color="primary" [style.display]="'inline-block'" (click)="exportQuoteOrders()">Export</button>
    </div>
  </div>
</div>
</div>
